<mat-card data-at-serial-number-modal *ngIf="heatingCircuitNameFeature$ | async as feature">
  <mat-card-header>
    <mat-card-title class="!flex flex-row justify-between items-center">
      <div>
        {{ 'EDIT_HEATING_CIRCUIT_NAME_MODAL.TITLE' | translate }}
      </div>
      <button
        data-at-close-edit-heating-circuit-modal
        mat-icon-button
        gtm="onClose"
        gtmAction="Edit name"
        gtmCategory="editHeatingCircuitModal"
        (click)="onClose()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="!flex flex-row gap-[16px] justify-start items-start">
    <mat-form-field class="w-full" mat-input-height-large-label>
      <mat-label>{{ 'EDIT_HEATING_CIRCUIT_NAME_MODAL.LABEL' | translate }}</mat-label>
      <input
        #input
        gtm="onTextField"
        gtmAction="Heating circuit name"
        gtmCategory="editHeatingCircuitNameModal"
        [gtmOn]="['change', 'focus', 'blur']"
        [formControl]="circuitNameForm"
        (keyup)="
          circuitNameChange(
            circuitNameForm.value,
            feature.commands?.setName?.params?.name?.constraints?.maxLength
          )
        "
        data-at-heating-circuit-name-input
        matInput
        autocomplete="off"
        maxlength="{{ feature.commands?.setName?.params?.name?.constraints?.maxLength || 20 }}"
        fieldTextContentTooltip
      />
      <button
        *ngIf="circuitNameForm.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="onClear()"
      >
        <mat-icon>cancel</mat-icon>
      </button>
      <mat-error *ngIf="circuitNameForm.hasError('specialCharacters')">{{
        '+HEATING_CIRCUIT.CHANGE_NAME_ERROR_SPECIAL_CHARACTERS' | translate
      }}</mat-error>

      <mat-hint align="end"
        >{{ input.value.length || 0 }}/{{
          feature.commands?.setName?.params?.name?.constraints?.maxLength || 20
        }}</mat-hint
      >
    </mat-form-field>
    <button
      class="save-btn lt-md:!hidden flex-[150px] !min-w-[150px] max-w-[150px]"
      data-at-save-heating-circuit-name-button
      mat-raised-button
      gtm="onSave"
      gtmAction="Edit heating circuit name"
      gtmCategory="editHeatingCircuitNameModal"
      color="primary"
      (click)="onSaveHeatingCircuitName()"
      [disabled]="!circuitNameForm.valid"
    >
      {{ 'GENERAL.BUTTON.SAVE' | translate }}
    </button>
  </mat-card-content>
  <mat-card-actions class="flex flex-col gap-[8px] gt-sm:!hidden justify-start items-center">
    <button
      data-at-save-heating-circuit-name-button
      mat-raised-button
      gtm="onSave"
      gtmAction="Edit heating circuit name"
      gtmCategory="editHeatingCircuitNameModal"
      color="primary"
      (click)="onSaveHeatingCircuitName()"
      [disabled]="!circuitNameForm.valid"
    >
      {{ 'GENERAL.BUTTON.SAVE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
